// extracted by mini-css-extract-plugin
export default {"container":"I16v8XHunJ8faTMXZUwF","image":"oEt9m_uhY58zAJ713Sop","textContainer":"Dcp7yVx0OsHRpOFFp2_i"};